exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "\r\n.image-list {\r\n  display: flex;\r\n  flex-wrap: wrap;\r\n}\r\n", ""]);

